<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Historique des contacts</div>
        <div class="modal-body">
            <div class="tableHisto" *ngIf="listContact">
                <frg-table [keysBody]="listContact" [keysColumn]="contactColumnTable"
                    tableButton1="assets/icons/trash.svg" (onClick1)="deleteContact($event)"
                    tableButtonNewItem="assets/icons-white/add.svg" [isEdit]="isEdit"
                    (formSubmit)="changeContacts($event)" (formCancel)="closeHistoContactModal(false)"
                    [isCenterHeader]="true" [deleteDuringEdit]="isEdit" *ngIf="isEdit" class='reduce'></frg-table>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>